import { getSelectedServer } from "./apiServerStore"
import { getAccessToken } from "./authHelpers"



const apiRoute                  = '/api/v1'
export const loginRoute         = `${apiRoute}/auth/login`
export const userRoute          = `${apiRoute}/user`
export const workflowsRoute     = `${apiRoute}/workflow`
export const groupsRoute        = `${apiRoute}/group`
export const workflowGroupRoute = `${apiRoute}/workflow_group`
export const sectionScanRoute   = `${apiRoute}/section_scan`
export const isolatedScanRoute  = `${apiRoute}/isolated_scan`
export const isolatedScanIMURoute  = `${apiRoute}/isolated_scan_imu`
export const isolatedScanMotionRoute = `${apiRoute}/isolated_scan_motion`
export const isolatedScanThermalRoute = `${apiRoute}/isolated_scan_thermal`
export const analysisRoute      = `${apiRoute}/scan_analysis`
export const freehandsScanRoute = `${apiRoute}/freehand_scan`
export const scanMediaRoute     = `${apiRoute}/scan_media`
export const scopeWorkflowRoute = `${apiRoute}/scope_workflow`
export const claddingMaterialRoute = `${apiRoute}/cladding_material`
export const insulationMaterialRoute = `${apiRoute}/insulation_material`
export const locationRoute = `${apiRoute}/workflow_location`
export const workflowAnalysisRoute = `${apiRoute}/analysis`
export const isolatedScanSystemDataRoute = `${apiRoute}/isolated_scan_system_data`
export const processedSectionsRoute = `${apiRoute}/processed_section`

/**
 * Gets the response to a http fetch request.
 * 
 * @param url to make the request to
 * @param method http method to include in the request
 * @param body to include in the request
 * @param headers request headers. Default headers are json format with authorization token
 * 
 * @returns json response or error
 */
type GenericRequestOptions = {
  url: string;
  method: "POST" | "PUT" | "GET" | "DELETE";
  body?: string | null;
  headers?: HeadersInit | null;
  query?: Record<string, string | number | boolean | undefined>;
};

export const genericRequest = async ({
  url,
  method,
  body = null,
  headers = null,
  query,
}: GenericRequestOptions) => {
  try {
    const token = await getAccessToken();

    headers ??= {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    };

    const baseUrl = getSelectedServer();
    const fullUrl = new URL(`${baseUrl}${url}`);

    if (query) {
      Object.entries(query).forEach(([key, value]) => {
        if (value !== undefined) fullUrl.searchParams.set(key, String(value));
      });
    }

    console.log("Making request to:", fullUrl.toString());

    const response = await fetch(fullUrl.toString(), {
      method,
      body,
      headers,
      redirect: "error"
    });

    if (response.ok) return await response.json();

    if (response.status === 401)
      return Error("401", { cause: "Unauthorized" });

    if (response.status === 404) {
      return Error("Could not find resource", { cause: `${404}` })
    }

    const errorData = await response.json().catch(() => {
      throw Error("Request failed", { cause: `${response.status} ${response.statusText}` });
    });

    return Error(errorData.detail, { cause: `${response.status}` });

  } catch (error) {
    return Error(`An error occurred: ${error}`);
  }
};
